// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-1fd128b2]{background-color:var(--color-white-dark);height:100vh;overflow:auto}.app[data-v-1fd128b2],.wrapper[data-v-1fd128b2]{display:flex;flex-direction:column}.wrapper[data-v-1fd128b2]{flex-grow:1;position:relative}.content[data-v-1fd128b2]{margin-left:auto;margin-right:auto;position:relative;width:100%}img[data-v-1fd128b2]{display:none;margin-bottom:4rem}@media (min-width:768px){img[data-v-1fd128b2]{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
